var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documents"},_vm._l((_vm.documentsGrouped),function(item,i){return _c('documents-group',{key:`document-${i}`,attrs:{"show-date":_vm.showDate,"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }